/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { MdLibraryAdd } from "react-icons/md";
import { apiPath, RoutePath } from "../../utility/Constant";
import { deleteData } from "../../hooks/delete";
import { useState } from "react";

const ProjectCard = ({ project, user }) => {
  const [hidden, setHidden] = useState(false);
  const { addProject } = RoutePath;
  const { projectListApi } = apiPath;
  const handleDelete = (event) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData(`${projectListApi}/${event.target.id}`);
        setTimeout(() => {
          setHidden(true);
        }, 1000);
      }
    });
  };

  return (
    <div className={hidden && "hidden"}>
      {project ? (
        <div className="card bg-base-100 shadow-xl h-[20rem] rounded-md">
          <figure className="block h-[100%]">
            <img
              src={project.image}
              alt={project.image + " " + "Image"}
              className="min-h-[275px] object-cover w-full"
            />
          </figure>

          <div className="p-3 h-full flex flex-col justify-between">
            <h2 className="text-xl text-center uppercase font-semibold">
              {project.projectTitle}
            </h2>
            <div className="flex justify-center">
              <a
                target="_blank"
                href={project.projectLink}
                className="btn btn-link text-blue-600 hover:text-blue-400"
              >
                Visit
              </a>
            </div>

            <div className="card-actions justify-between">
              <a target="_blank" href={`https://innoviatech.dev/portfolio/${project._id}`}
                className="btn btn-outline btn-xs border-green-500 text-green-500 hover:bg-green-500 hover:border-green-500 hover:text-white rounded-md h-8 "
              >
                Preview
              </a>
              <Link
                to={`/projectList/${project._id}`}
                className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white rounded-md h-8 "
              >
                Edit
              </Link>
              {user === "admin" && (
                <button
                  id={project._id}
                  onClick={handleDelete}
                  className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white rounded-md h-8 "
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Link
          to={addProject}
          className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full "
        >
          <p className="text-8xl">
            <MdLibraryAdd />
          </p>
        </Link>
      )}
    </div>
  );
};

export default ProjectCard;
